export const TRUNCATE_LENGTH_INFORMATION = 300
